import { UspBoxComponent } from './der-tailormade-usp-box.component.js';

export * from './der-tailormade-usp-box.component.js';
export default UspBoxComponent;

UspBoxComponent.define('der-tailormade-usp-box');

declare global {
    interface HTMLElementTagNameMap {
        'der-tailormade-usp-box': UspBoxComponent;
    }
}
